$(document).ready(function () {
   $('br').attr('aria-hidden','true');
   $('hr').attr('aria-hidden','true');
});

//External links
$(document).ready(function () {
    $('a[href^="http://"], a[href^="https://"]').each(function () {
      const $link = $(this);
  
      const currentHost = window.location.hostname.replace('www.', '');
      const linkHost = this.hostname.replace('www.', '');
  
      // Skip internal links
      if (linkHost === currentHost || !linkHost) return;
  
      const warningText = 'opens in a new tab';
  
      let ariaLabel = $link.attr('aria-label');
  
      // Case 1: aria-label exists but warning is missing
      if (ariaLabel) {
        if (!ariaLabel.toLowerCase().includes(warningText)) {
          ariaLabel = `${ariaLabel} - ${warningText}`;
          $link.attr('aria-label', ariaLabel);
        }
      } else {
        // Case 2: aria-label does not exist, build one
  
        const imgAlt = $link.find('img[alt]').first().attr('alt') || '';
  
        const visibleText = $link
          .clone()
          .children()
          .remove()
          .end()
          .text()
          .trim();
  
        const labelParts = [];
  
        if (imgAlt) labelParts.push(imgAlt);
        if (visibleText) labelParts.push(visibleText);
  
        labelParts.push(warningText);
  
        ariaLabel = labelParts.join(' - ');
        $link.attr('aria-label', ariaLabel);
      }
  
      // Apply external link behavior
      $link.attr({
        'title': ariaLabel,
        'target': '_blank',
        'rel': 'noopener noreferrer'
      });
  
      $link.addClass('external-link');
    });
});


// List of Email aria label assigned
$(document).ready(function() {
    
    $('a[href^="mailto:"]').each(function() {
      
      let email = $(this).attr('href').replace('mailto:', '').trim();
      
      
      if (email) {
        
        email = decodeURIComponent(email)   
                .split('?')[0]              
                .split('&')[0];              
        
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (emailRegex.test(email)) {
          $(this).attr('aria-label', 'Email Address: ' + email);
        } else {
          
          console.warn('Invalid email address:', email);
        }
      }
    });
});

// Label For Phone Numbers
$(document).ready(function() {
    $('a[href^="tel:"]').each(function() {
      const telNumber = $(this).attr('href').replace('tel:', ''); // Remove "tel:" prefix
      const ariaNumber = telNumber.replace(/-/g, '.'); // Replace hyphens with dots
      // Use template literals for proper string interpolation
      $(this).attr('aria-label', `Phone Number: ${ariaNumber}`);
    });
});

//Empty Heading issue Fixed
$(document).ready(function() {
  $('h1, h2, h3, h4, h5, h6').each(function() {
    var $heading = $(this);
    if ($.trim($heading.text()).length === 0 && $heading.children('br').length === $heading.children().length) {
      $heading.remove();
    }
  });
});

//Review tabindex +ve remove
$(document).ready(function () {
  $('div[role="button"][tabindex]').attr('tabindex', '0');
});

// Heading sequence into the reviews
$(document).ready(function () {
  $('.wise-border-l-2 h5').each(function () {
    const $heading = $(this);

    const $paragraph = $('<p>', {
      html: $heading.html(),
      class: $heading.attr('class')
    });

    $heading.replaceWith($paragraph);
  });
});